export default __webpack_public_path__ + "static/media/menu.f41bf14f.svg";